import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "../keys";
import { queryApi, CreditsResponse } from "../api";
import { getTokens } from "../../utils/tokens";

/** staleTime 15 с для credits (відповідає частому оновленню балансу) */
const CREDITS_STALE_MS = 15 * 1000;

export function useCreditsQuery() {
  const hasToken = !!getTokens()?.access_token;

  return useQuery({
    queryKey: queryKeys.credits,
    queryFn: queryApi.fetchCredits,
    enabled: hasToken,
    staleTime: CREDITS_STALE_MS,
  });
}

export type { CreditsResponse };
